import { dialogPageTypes } from "../../../const/dialogPageTypes";
import { openDialog, setPageType } from "../../../redux/reducers/DialogGeneral";

export const handleDialogToEditPostazioni = ({ dialogType, rowInfo }, dispatch) => {
    dispatch(setPageType(dialogPageTypes.postazioni));
    dispatch(openDialog({ dialogType, rowInfo }));
  };
  